module.exports = __webpack_public_path__ + "static/media/3.cd4bbea5.jpg";